<template>
        <sc-streaming
            v-if="show"
            :key="reloadKey"
            :streams="localStreams"
            :stream-settings="streamSettings"
            :version="version"
            @reload-stream="reloadStream"
        />
</template>

<script>
import ScStreaming from './scStreaming';

export default {
    components: {
        ScStreaming
    },
    props: {
        streams: Object,
        streamSettings: Object,
        version: String
    },
    data() {
        return {
            reloadKey: 0,
            show: true,
            localStreams: this.streams
        };
    },
    methods: {
        reloadStream() {
            this.show = false;
            this.localStreams.data = this.localStreams.data.slice(1);
            setTimeout(() => {
                this.reloadKey++;
                this.show = true;
            }, 500);
        }
    }
};
</script>
